export default "assets/images/logo-f124b300.png";